import { render, staticRenderFns } from "./depositChannel.vue?vue&type=template&id=0ed6d7cd&scoped=true"
import script from "./depositChannel.vue?vue&type=script&lang=js"
export * from "./depositChannel.vue?vue&type=script&lang=js"
import style0 from "./depositChannel.vue?vue&type=style&index=0&id=0ed6d7cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed6d7cd",
  null
  
)

export default component.exports